import classNames from 'classnames';
import PropTypes from 'prop-types';

const AdFormatItem = ({ Icon, displayName, checked }) => {
  return (
    <div
      className={classNames(
        'flex py-6 px-6 border-2 rounded w-full items-center cursor-pointer justify-center gap-2',
        checked ? 'border-[#1B4332] bg-[#1B4332]/15' : 'border-[#E5E5E5] text-[#84818A]',
      )}
    >
      <Icon color={checked ? '#1B4332' : '#84818A'} />
      <span>{displayName}</span>
    </div>
  );
};

AdFormatItem.propTypes = {
  Icon: PropTypes.elementType,
  displayName: PropTypes.string,
  checked: PropTypes.bool,
};

export default AdFormatItem;
